import React from 'react';
import type { IconProps } from '../types';

export const LoadingOHIFMark = (props: IconProps) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="102.000000pt"
    height="104.000000pt"
    viewBox="0 0 102.000000 104.000000"
    {...props} // Spread the props to allow for additional SVG attributes
  >
    <g
      transform="translate(0.000000,104.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M474 999 c-62 -14 -144 -69 -185 -123 -66 -87 -85 -190 -54 -294 15
-49 18 -52 48 -52 40 0 137 14 214 31 l58 12 -35 9 c-76 21 -139 99 -140 174
0 38 43 124 74 146 90 65 223 33 270 -66 23 -48 21 -123 -5 -165 -11 -18 -18
-35 -16 -37 5 -5 151 81 164 98 8 10 6 26 -8 63 -36 97 -122 173 -225 200 -64
17 -99 17 -160 4z"
      />
      <path
        d="M513 885 c-40 -17 -73 -69 -73 -113 0 -111 116 -174 208 -114 78 51
64 191 -23 228 -43 17 -71 17 -112 -1z"
      />
      <path
        d="M968 883 c6 -2 12 -19 12 -36 0 -53 -109 -143 -269 -222 -148 -73
-314 -115 -455 -115 -120 0 -177 47 -148 122 6 18 10 33 8 35 -8 8 -74 -58
-86 -86 -17 -43 2 -96 43 -119 26 -13 57 -17 152 -17 138 1 246 26 403 93 174
75 337 198 371 280 12 29 12 35 -4 52 -10 11 -23 20 -29 19 -6 0 -6 -3 2 -6z"
      />
      <path
        d="M820 623 c-99 -79 -283 -158 -428 -185 -35 -7 -66 -17 -69 -24 -7
-18 163 -350 189 -368 33 -23 66 -20 97 12 17 17 71 131 150 315 68 159 122
290 120 291 -2 2 -29 -16 -59 -41z"
      />
    </g>
  </svg>
);

export default LoadingOHIFMark;
